import React, { Component } from "react";
import CESSVG from "../../../Assets/svg/CESSVG.svg";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { withRouterHooks } from "../../../withRouters/withRoutersHook";
import PropTypes from "prop-types";
import { LayoutDashboard, MessageCircle, Mail, Phone, Voicemail, ArrowLeft } from "lucide-react";

const NAV_ITEMS = [
  { to: "/dashboard/message-overview", key: "overview", icon: LayoutDashboard, label: "Overview" },
  { to: "/dashboard/message-overview/whatsapp", key: "whatsapp", icon: MessageCircle, label: "WhatsApp" },
  { to: "/dashboard/message-overview/email", key: "email", icon: Mail, label: "Email" },
  { to: "/dashboard/message-overview/calls", key: "calls", icon: Phone, label: "Calls" },
  { to: null, key: "voicemail", icon: Voicemail, label: "Voice Mail", disabled: true },
];

class MessagingSideBar extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
  };

  getActiveKey = () => {
    const { pathname } = this.props.location;
    if (pathname === "/dashboard/message-overview") return "overview";
    if (pathname.includes("/dashboard/message-overview/whatsapp")) return "whatsapp";
    if (pathname.includes("/dashboard/message-overview/email")) return "email";
    if (pathname.includes("/dashboard/message-overview/calls")) return "calls";
    return null;
  };

  renderNavItem = ({ to, key, icon: Icon, label, disabled }) => {
    const active = this.getActiveKey() === key;

    const inner = (
      <div
        className={`flex items-center gap-3 px-3 py-2.5 rounded-lg font-inter text-sm font-normal tracking-wide transition-all duration-150 cursor-pointer ${
          disabled
            ? "text-gray-600 cursor-not-allowed opacity-50"
            : active
            ? "bg-gradient-to-r from-primary-blue to-blue-400 text-white shadow-md"
            : "text-gray-400 hover:bg-gradient-to-r hover:from-white/10 hover:to-white/5 hover:text-white"
        }`}
      >
        <Icon
          className={`w-[1.125rem] h-[1.125rem] shrink-0 flex-none ${
            active ? "text-white" : disabled ? "text-gray-600" : "text-gray-400"
          }`}
        />
        <span className="flex-1 whitespace-nowrap overflow-hidden">{label}</span>
      </div>
    );

    if (disabled || !to) {
      return <div key={key}>{inner}</div>;
    }

    return (
      <Link key={key} to={to}>
        {inner}
      </Link>
    );
  };

  render() {
    return (
      <div className="group flex flex-col w-14 hover:w-[16.625rem] h-screen bg-[#0f1f3d] z-30 transition-[width] duration-200 ease-in-out overflow-hidden shadow-none hover:shadow-2xl">
        {/* Logo */}
        <div className="flex items-center gap-3 py-5 px-3.5 border-b border-white/5 overflow-hidden">
          <Link to="/dashboard" className="shrink-0">
            <div className="w-7 h-7 bg-white rounded-md flex items-center justify-center">
              <img src={CESSVG} alt="CES" className="w-5 h-5" />
            </div>
          </Link>
          <span className="font-SFPro font-semibold text-white text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-150 delay-75">
            Messages
          </span>
        </div>

        {/* Nav items */}
        <nav className="flex-1 overflow-y-auto overflow-x-hidden px-2 py-3 flex flex-col gap-0.5">
          {NAV_ITEMS.map((item) => this.renderNavItem(item))}
        </nav>

        {/* Back to main dashboard */}
        <div className="px-2 py-3 border-t border-white/10">
          <Link to="/dashboard">
            <div className="flex items-center gap-3 px-3 py-2.5 rounded-lg font-inter text-sm font-normal tracking-wide transition-all duration-150 cursor-pointer text-gray-400 hover:bg-gradient-to-r hover:from-white/10 hover:to-white/5 hover:text-white">
              <ArrowLeft className="w-[1.125rem] h-[1.125rem] shrink-0 flex-none text-gray-400" />
              <span className="flex-1 whitespace-nowrap overflow-hidden">Main Dashboard</span>
            </div>
          </Link>
        </div>
      </div>
    );
  }
}

export default withRouterHooks(connect(null, {})(MessagingSideBar));
